import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-800 text-white w-full" data-id="element-63">
      <div className="container mx-auto px-4 py-12" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-65">
          {/* Company Info */}
          <div data-id="element-66">
            <div className="mb-4" data-id="element-67">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kpFCHAhXhoTzrUAWGaPcWo/Scherm%C2%ADafbeelding_2025-07-16_om_10.00.16.png" alt="Experience Hikes Logo" className="h-16 bg-white p-2 rounded-md" data-id="element-68" />
            </div>
            <p className="text-gray-400 mb-4" data-id="element-69">
              Discover new paths and experience unforgettable hiking adventures
              across Europe's most beautiful destinations.
            </p>
            <div className="flex space-x-4" data-id="element-70">
              <a href="https://www.facebook.com/experiencehikes/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" data-id="element-71">
                <FacebookIcon size={20} data-id="element-72" />
              </a>
              <a href="https://www.instagram.com/experience.hikes/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" data-id="element-73">
                <InstagramIcon size={20} data-id="element-74" />
              </a>
            </div>
            <div className="mt-4" data-id="element-75">
              <a href="https://sto-garant.nl" target="_blank" rel="noopener noreferrer" data-id="element-76">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/du92o5vkTqwP3qZ9YayNYo/logo.png" alt="STO Garant Logo" className="h-16 bg-white p-1 rounded-md" data-id="element-77" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-78">
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2" data-id="element-79">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-80">
              <li data-id="element-81">
                <Link to="/greece" className="text-gray-400 hover:text-white transition" data-id="element-82">
                  Greece
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/cyprus" className="text-gray-400 hover:text-white transition" data-id="element-84">
                  Cyprus
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/spain" className="text-gray-400 hover:text-white transition" data-id="element-86">
                  Spain
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/morocco" className="text-gray-400 hover:text-white transition" data-id="element-88">
                  Morocco
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/blogs" className="text-gray-400 hover:text-white transition" data-id="element-90">
                  Blogs
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/about" className="text-gray-400 hover:text-white transition" data-id="element-92">
                  About Us
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/contact" className="text-gray-400 hover:text-white transition" data-id="element-94">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-95">
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2" data-id="element-96">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-97">
              <li className="flex items-start" data-id="element-98">
                <MapPinIcon size={20} className="text-teal-500 mr-2 mt-1 flex-shrink-0" data-id="element-99" />
                <span className="text-gray-400" data-id="element-100">
                  Office: The Hague, the Netherlands
                </span>
              </li>
              <li className="flex items-start" data-id="element-101">
                <span className="text-teal-500 mr-2 mt-1 flex-shrink-0" data-id="element-102">
                  KVK
                </span>
                <span className="text-gray-400" data-id="element-103">
                  nr. 77858786 Chamber of Commerce
                </span>
              </li>
              <li className="flex items-center" data-id="element-104">
                <PhoneIcon size={20} className="text-teal-500 mr-2 flex-shrink-0" data-id="element-105" />
                <span className="text-gray-400" data-id="element-106">
                  Tel. +31 681180400 (Netherlands)
                </span>
              </li>
              <li className="flex items-center" data-id="element-107">
                <MailIcon size={20} className="text-teal-500 mr-2 flex-shrink-0" data-id="element-108" />
                <span className="text-gray-400" data-id="element-109">Experiencehikes@gmail.com</span>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-110">
            <h3 className="text-lg font-bold mb-4 border-b border-gray-700 pb-2" data-id="element-111">
              Newsletter
            </h3>
            <p className="text-gray-400 mb-4" data-id="element-112">
              Subscribe to our newsletter for the latest trip updates and
              special offers.
            </p>
            <form className="space-y-3" data-id="element-113">
              <input type="email" placeholder="Your email address" className="w-full px-4 py-2 rounded-md bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-teal-500" data-id="element-114" />
              <button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-115">
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400" data-id="element-116">
          <p className="mb-4" data-id="element-117">
            © {new Date().getFullYear()} Experience Hikes. All rights reserved.
          </p>
          <div className="flex justify-center space-x-6" data-id="element-118">
            <Link to="/privacy-policy" className="hover:text-white transition" data-id="element-119">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="hover:text-white transition" data-id="element-120">
              Terms & Conditions
            </Link>
            <Link to="/cookie-policy" className="hover:text-white transition" data-id="element-121">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};